import { createContext } from 'react';

export interface ChartTotalProps {
  itemsTotal: number;
  priceTotal: number;
};

export interface ChartProps {
  chartTotal: ChartTotalProps;
  setChartTotal: React.Dispatch<React.SetStateAction<ChartTotalProps>>;
};

const contextDefault: ChartProps = {
  chartTotal: {
    itemsTotal: 0,
    priceTotal: 0,
  },
  setChartTotal: () => {},
};

const ChartContext = createContext<ChartProps>(contextDefault);

export default ChartContext;